export default __webpack_public_path__ + "static/media/icon-20-icn-event-turn-2.2a4dbcac.svg";